import { DASHBOARD_SLIDER_PAGE_LOADED, DASHBOARD_SLIDER_PAGE_UNLOADED, ASYNC_START } from '../constants/actionTypes';

const checkIfLoggedOut = (token) => {
  var redirectTo = null;
  if(token == null || token === '') {
    redirectTo = "/login"
  }
  return redirectTo
}

export default (state = {}, action) => {
  switch (action.type) {
    case DASHBOARD_SLIDER_PAGE_LOADED:
      return {
        ...state,
        redirectTo: checkIfLoggedOut(action.token),
        config:action.payload ? action.payload : null
      };
    case DASHBOARD_SLIDER_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js